// extracted by mini-css-extract-plugin
export default {"cart-total__container":"CartTotal_cart-total__container__wFlbJ","subtotal":"CartTotal_subtotal__R5E7X","total":"CartTotal_total__yAOMT"};